import BugReportToast from "./Container";

export default BugReportToast;
